(function () {

  document.addEventListener("click", async function (e) {

    const removeBtn = e.target.closest(".cart__subscription-remove");
    if (!removeBtn) return;

    e.preventDefault();

    const subscriptionId = removeBtn.dataset.subscriptionId;
    if (!subscriptionId) return;

    await new Promise(resolve => setTimeout(resolve, 350));
    const cart = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());

    const updates = {};
    cart.items.forEach((item) => {
      if (item.properties && item.properties._SubscriptionId === subscriptionId) {
        updates[item.key] = 0;
      }
    });

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    });

    // if (window.removeRegularShippingIfNeeded) {
    //   await window.removeRegularShippingIfNeeded();
    // }

    location.reload();
  });

})();

let subscriptionShippingSyncing = false;

window.syncSubscriptionShipping = async function () {
  if (subscriptionShippingSyncing) return;

  subscriptionShippingSyncing = true;

  try {
    const cart = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());

    // Is there any regular (non-subscription) product?
    const hasRegularProducts = cart.items.some(item => {
      return (
        !item.properties?._SubscriptionId &&
        !item.properties?.["_Subscription Shipping"]
      );
    });

    // All subscription shipping lines
    const shippingItems = cart.items.filter(item =>
      item.properties?.["_Subscription Shipping"] === "Yes"
    );

    for (const shipping of shippingItems) {

      const subscriptionId = shipping.properties._SubscriptionId;

      // Matching coffee line
      const coffee = cart.items.find(item =>
        item.properties?._SubscriptionId === subscriptionId &&
        !item.properties?.["_Subscription Shipping"]
      );

      if (!coffee) continue;

      const deliveries = parseInt(
        coffee.properties["Total Deliveries"] || 0,
        10
      );

      const expectedQty = hasRegularProducts
        ? deliveries
        : Math.max(deliveries - 1, 0);

      if (shipping.quantity !== expectedQty) {

        const line = cart.items.findIndex(item => item.key === shipping.key);

        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            line: line + 1,
            quantity: expectedQty
          })
        });

      }
    }

  } catch (err) {
    console.error("Subscription shipping sync failed", err);
  } finally {
    subscriptionShippingSyncing = false;
  }
};

document.addEventListener("click", function (e) {

  const el = e.target.closest(
    "[data-item-remove], .cart__quantity-minus, .cart__quantity-plus"
  );

  if (!el) return;

  setTimeout(() => {

    if (window.syncSubscriptionShipping) {
      window.syncSubscriptionShipping();
    }

  }, 700);

});
document.addEventListener("DOMContentLoaded", () => {
  if (window.syncSubscriptionShipping) {
    window.syncSubscriptionShipping();
  }
});
document.addEventListener("theme:product:added", async function () {
  if (window.syncSubscriptionShipping) {
    await window.syncSubscriptionShipping();
  }
});